function formatearFechaES(fecha) {
    const date = new Date(fecha);

    const fechaParte = new Intl.DateTimeFormat("es-ES", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
    }).format(date);

    const horaParte = new Intl.DateTimeFormat("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    }).format(date);

    return `${fechaParte} a las ${horaParte}`;
}

function formatearHoraES(fecha) {
    const date = new Date(fecha);

    const horaParte = new Intl.DateTimeFormat("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    }).format(date);

    return `${horaParte}`;
}

const ReceiptPrintView = ({ data }) => (
    <html>
        <head>
            <title>Recibo de Cobro</title>
            <style>
                {`
           body { font-family: Arial; padding: 24px; }
           h1, h2 { margin-bottom: 8px; }
           table { width: 100%; border-collapse: collapse; margin-bottom: 16px; }
           th, td { border-bottom: 1px solid #ccc; padding: 6px; }
           .total { font-weight: bold; }
           .omitted { color: #666; }
           .notes {
                margin-top: 8px;
                margin-bottom: 8px;
                padding: 8px 12px;
                background: #f5f5f5;
                border-left: 4px solid #999;
                font-size: 13px;
            }

            .notes ul {
                margin: 4px 0 0 16px;
                padding: 0;
            }

            .notes li {
                margin-bottom: 4px;
            }
        `}
            </style>
        </head>
        <body>
            <h1>Recibo de Cobro</h1>
            <p><strong>Ruta:</strong> {data.routeName}</p>
            <p><strong>Fecha:</strong> {data.date}</p>

            {data.salidas.map(s => (
                <div key={s.id}>
                    <h2>Salida {formatearFechaES(s.date)}</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Unidad</th>
                                <th>Geocerca</th>
                                <th>Programada</th>
                                <th>Ingreso</th>
                                <th>Diferencia</th>
                                <th>Importe</th>
                            </tr>
                        </thead>
                        <tbody>
                            {s.tickets.map(t => (
                                <tr key={t.id}>
                                    <td>{t.device}</td>
                                    <td>{t.geofence}</td>
                                    <td>{t.expectedTime ? formatearHoraES(t.expectedTime) : '—'}</td>
                                    <td>{t.enterTime ? formatearHoraES(t.enterTime) : '—'}</td>
                                    <td>{t.difference}</td>
                                    <td>
                                        {(t.forgiven ? '0 (Excusado)' : (t.progressPunishment > 0 ? t.progressPunishment : (t.globalCostPunishment > 0 ? t.globalCostPunishment : (t.difference > 0 ? t.punishment : 0))))}
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>

                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85em', marginBottom: '8px' }}>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left', padding: '4px 8px', borderBottom: '1px solid #ccc' }}></th>
                                <th style={{ textAlign: 'center', padding: '4px 8px', borderBottom: '1px solid #ccc' }}>Subieron</th>
                                <th style={{ textAlign: 'center', padding: '4px 8px', borderBottom: '1px solid #ccc' }}>Bajaron</th>
                                <th style={{ textAlign: 'center', padding: '4px 8px', borderBottom: '1px solid #ccc' }}>En unidad</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[
                                { label: 'Puerta 1', inn: s.counter1In ?? 0, out: s.counter1Out ?? 0 },
                                { label: 'Puerta 2', inn: s.counter2In ?? 0, out: s.counter2Out ?? 0 },
                                {
                                    label: 'Total',
                                    inn: (s.counter1In ?? 0) + (s.counter2In ?? 0),
                                    out: (s.counter1Out ?? 0) + (s.counter2Out ?? 0),
                                    isTotal: true,
                                },
                            ].map(({ label, inn, out, isTotal }) => (
                                <tr key={label} style={isTotal ? { fontWeight: 'bold', borderTop: '1px solid #ccc' } : {}}>
                                    <td style={{ padding: '4px 8px' }}>{label}</td>
                                    <td style={{ textAlign: 'center', padding: '4px 8px', color: '#065f46' }}>{inn}</td>
                                    <td style={{ textAlign: 'center', padding: '4px 8px', color: '#cc0000' }}>{out}</td>
                                    <td style={{ textAlign: 'center', padding: '4px 8px' }}>{inn - out}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {(s.computedNotes || []).length > 0 && (
                        <div className="notes">
                            <strong>Notas:</strong>
                            <ul>
                                {s.computedNotes.map((note, idx) => (
                                    <li key={idx}>{note}</li>
                                ))}
                            </ul>
                        </div>
                    )}

                    <p className="total">Total salida: ${s.total.toFixed(2)}</p>
                </div>
            ))}

            {data.extraCharges?.length > 0 && (
                <>
                    <h3>Cargos adicionales</h3>
                    <ul>
                        {data.extraCharges.map(c => (
                            <li key={c.id}>
                                {c.description} — ${Number(c.amount).toFixed(2)}
                            </li>
                        ))}
                    </ul>
                    <strong>
                        Total cargos adicionales: ${data.extraChargesTotal.toFixed(2)}
                    </strong>
                </>
            )}


            {data.omittedSalidas.length > 0 && (
                <>
                    <h2>Salidas omitidas</h2>
                    <ul>
                        {data.omittedSalidas.map(o => (
                            <li key={o.id}>
                                Salida del dia:
                                {' '}
                                {formatearFechaES(o.date)}
                                {' '}
                                {o.reason && ` — ${o.reason}`}
                            </li>
                        ))}
                    </ul>
                </>
            )}

            {data.excusedTickets.length > 0 && (
                <>

                    <h2>Excusas aplicadas</h2>
                    <ul>
                        {data.excusedTickets.map((e, idx) => (
                            <li key={idx}>
                                Salida del dia:
                                {' '}
                                {(() => {
                                    const salida = data.salidas.find(s => s.id == e.salidaId);
                                    return salida ? formatearFechaES(salida.date) : '';
                                })()}
                                -
                                {' '}
                                Excusa: {e.excuse} -
                                {' '}
                                Geocerca: {(() => {
                                    const salida = data.salidas.find(s => s.id == e.salidaId);
                                    const ticket = salida?.tickets.find(t => t.id === e.ticketId);
                                    return ticket?.geofence || '';
                                })()}

                                {' '}(${e.punishment})
                            </li>
                        ))}
                    </ul>
                </>
            )}

            <h2>Total a cobrar: ${data.globalTotal.toFixed(2)}</h2>
        </body>
    </html>
);

export default ReceiptPrintView;